import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./filterChip.module.css";

interface FilterChipProps {
    children: React.ReactNode;
    onRemove: () => void;
}

export const FilterChip = ({ children, onRemove }: FilterChipProps) => (
    <div className={styles.filterChipItem}>
        <p className={styles.filterChipText}>{children}</p>
        <div className={styles.iconContainer}>
            <CloseIcon onClick={onRemove} className={styles.closeIcon} />
        </div>
    </div>
);
